module.exports = __webpack_public_path__ + "img/f1.cf8b4823.png";